import { createBrowserHistory } from 'history';
// import(`../modules/AutocompleteAddress`);

export default class ServiceFormController {
    constructor() {
        /** @type {delegate} */
        this.delegate = null;
        this.sliderValueMapper = null;

        this.content = null;

        this.animationDuration = 400;

        this.currentPageSelector = '';
        this.totalPagesSelector = '';
        this.formSelector = '.formBlock form';

        this.history = createBrowserHistory();
        this.listener = null;
        this.currentPath = location.pathname;

        this.init();
        window.app.detectBrowser();

        // Settings for serialNumber check
        this.serialValidator = {
            apiEndpoint: `/api/SerialNumberApi/ValidateSerialNumber?serialNumber=`,
            abortController: null,
            waiterTime: 1000,
            changeWaiter: null,
        };

        this.addressValidator = {
            selector: `[data-address-form]`,
            attribute: `data-address-form`,
            apiEndpoint: `/api/zipcode/getaddress`,
        };
    }

    init() {
        window.history.scrollRestoration = 'manual';
        document.documentElement.scrollTop = 0;
        let modules = [
            import(/* webpackChunkName: "modules/delegate" */ 'delegate'),
            import(/* webpackChunkName: "modules/datepicker" */ '@duetds/date-picker/custom-element'),
        ];

        // .firstElementChild polyfill
        (function (constructor) {
            if (
                constructor &&
                constructor.prototype &&
                constructor.prototype.firstElementChild == null
            ) {
                Object.defineProperty(
                    constructor.prototype,
                    'firstElementChild',
                    {
                        get: function () {
                            var node,
                                nodes = this.childNodes,
                                i = 0;
                            while ((node = nodes[i++])) {
                                if (node.nodeType === 1) {
                                    return node;
                                }
                            }
                            return null;
                        },
                    }
                );
            }
        })(window.Node || window.Element);

        document.querySelector('main').classList.add('hidden');

        Promise.all(modules).then((modules) => {
            this.delegate = modules[0].default;

            this.DuetDatePicker = modules[1].DuetDatePicker;

            this.content = document.querySelector('main');
            this.setEventListeners();
            document.querySelector('main').classList.remove('hidden');
            this.initForm();

            document.documentElement.classList.remove('disableScroll');
        });


    }

    initForm() {
        // This method should be called whenever a new form is loaded async

        // if (this.content.querySelector('input[type="range"]')) {
        //     this.handleSliderInput();
        // }

        // Validation handling
        // if (this.content.querySelectorAll('.input-validation-error').length) {
        //     this.content.querySelector('.input-validation-error').focus();
        // }

        if (this.content.querySelector('form .inputRow')) {
            this.content
                .querySelectorAll('form .inputRow input')
                .forEach((input) => {
                    const label = input.parentNode.querySelector('label');

                    if (input.value.length) {
                        label.classList.add('entered');
                    }

                    input.addEventListener('focus', (e) => {
                        label.classList.add('active');
                    });

                    input.addEventListener('blur', (e) => {
                        label.classList.remove('active');
                    });
                });
        }

        if (this.content.querySelector('.formBlock form')) {
            var form = $('.formBlock form');
            form.data('unobtrusiveValidation', null);
            form.data('validator', null);
            $.validator.unobtrusive.parse(form);
            let initialFilled = true;

            this.content
                .querySelectorAll(`[data-popup-trigger]`)
                .forEach((popupTrigger) => {
                    const id = popupTrigger.dataset.popupTrigger;
                    const popup = this.content.querySelector(
                        `[data-popup="${id}"]`
                    );

                    if (popup) {
                        const background = popup.querySelector(`.background`);

                        popupTrigger.addEventListener(`click`, (e) => {
                            e.preventDefault();
                            popup.classList.add(`active`);
                        });

                        if (background) {
                            background.addEventListener(`click`, () => {
                                popup.classList.remove(`active`);
                            });
                        }

                        document.addEventListener(`keydown`, (e) => {
                            if (e.key === 'Escape' || e.key === 'Esc') {
                                if (popup.classList.contains(`active`)) {
                                    popup.classList.remove(`active`);
                                }
                            }
                        });
                    }
                });

            this.content.querySelectorAll('[data-val="true"]').forEach(input => {
                if (initialFilled && $(input).is(':visible')) {
                    if (!input.value) initialFilled = false;
                    if (input.type === "radio" || input.type === "checkbox") {
                        let rValueCheck = false;
                        document.querySelectorAll(`[name=${input.name}]`).forEach(function (r) {
                            if (r.checked) rValueCheck = true;
                        })
                        initialFilled = rValueCheck;
                    }
                }
                $(input).on('change', e => {
                    let allAreFilled = true;
                    this.content.querySelectorAll('form [data-val="true"]').forEach(function (i) {
                        if (!$(i).is(":visible")) {
                            return;
                        }
                        if (!allAreFilled) return;
                        if (!i.value) allAreFilled = false;
                        if (i.type === "radio" || i.type === "checkbox") {
                            let radioValueCheck = false;
                            document.querySelectorAll(`[name=${i.name}]`).forEach(function (r) {
                                if (r.checked) radioValueCheck = true;
                            })
                            allAreFilled = radioValueCheck;
                        }
                    })
                    if (allAreFilled) {
                        this.content.querySelector('button[type="submit"]').removeAttribute('disabled');
                        this.content.querySelector('button[type="submit"]').classList.remove(`disabledButton`);
                    } else {
                        this.content.querySelector('button[type="submit"]').classList.add(`disabledButton`);
                    }
                });
            });
            if (initialFilled) {
                this.content.querySelector('button[type="submit"]').removeAttribute('disabled');
                this.content.querySelector('button[type="submit"]').classList.remove(`disabledButton`);
            } else {
                this.content.querySelector('button[type="submit"]').classList.add(`disabledButton`);
            }
        }

        // Handler for clicking a disabled button
        this.content
            .querySelectorAll('.disabledButton').forEach(button => {     
                button.addEventListener('click', (e) => {
                    const button =
                        this.content.querySelector('button[disabled]');
                    if (button && !button.classList.contains('wiggle')) {
                        button.classList.add('wiggle');
                        setTimeout(() => {
                            button.classList.remove('wiggle');
                        }, 400);
    
                        // highlight required fields
                        $(this.content.querySelector('form')).valid();
                    }
                });
            })

        if (this.content.querySelector(this.addressValidator.selector)) {
            // The selector will either be "manual" or "autocomplete", based on language settings
            const addressForm = this.content.querySelector(
                this.addressValidator.selector
            );
            const mode = addressForm.getAttribute(
                this.addressValidator.attribute
            );

            const addressPreviewer = {
                element: this.content.querySelector(`.addressPreview`),

                clear: () => {
                    if (addressPreviewer.element) {
                        addressPreviewer.element.innerHTML = ``;
                    }
                },
                
                setAddress: (data) => {
                    if (addressPreviewer.element) {
                        addressPreviewer.element.innerText = `${data.street} ${
                            data.houseNumber
                        }${data.houseNumberAddition}${
                            data.postalCode ? `,` : ``
                        } ${data.postalCode}${data.city ? `,` : ``} ${
                            data.city
                        }`;
                    }
                },

                wrongAddress: () => {
                    if (addressPreviewer.element) {
                        addressPreviewer.element.innerText = `${
                            addressForm.getAttribute('data-label-no-address') ||
                            'Adres niet gevonden'
                        }`;
                    }
                },
            };

            if (mode == 'manual') {
                const zipcodeInput = this.content.querySelector(
                    'input[name="PostalCode"]'
                );
                const housenumberInput = this.content.querySelector(
                    'input[name="HouseNumber"]'
                );

                const housenumberAdditionInput = this.content.querySelector(
                    `input[name="HouseNumberAddition"]`
                );

                if (zipcodeInput && housenumberInput) {
                    const countryCode = this.content.querySelector('input[name=Country]').value;

                    const validate = () => {
                        const params = new URLSearchParams({
                            CountryCode: countryCode,
                            Zipcode: zipcodeInput.value.trim(),
                            Housenumber: housenumberInput.value.trim(),
                        });

                        if (housenumberAdditionInput.value) {
                            params.append(`HousenumberAddition`, housenumberAdditionInput.value.trim());
                        }

                        fetch(
                            `${
                                this.addressValidator.apiEndpoint
                            }?${params.toString()}`,
                            {}
                        )
                            .then((response) => {
                                if (response.ok) {
                                    response.json().then((data) => {
                                        if (data) {
                                            addressPreviewer.setAddress(data);
                                            this.content.querySelector('input[name=Street]').value = data.street;
                                            this.content.querySelector('input[name=City]').value = data.city;
                                        } else {
                                            addressPreviewer.wrongAddress();
                                        }
                                    });
                                } else {
                                    addressPreviewer.wrongAddress();
                                }
                            })
                            .catch((error) => {
                                console.error(error);
                                addressPreviewer.clearAddress();
                            });
                    };

                    [zipcodeInput, housenumberInput, housenumberAdditionInput].forEach((input) => {
                        input.addEventListener('blur', () => {
                            if (zipcodeInput.value && housenumberInput.value) {
                                validate();
                            } else {
                                addressPreviewer.clearAddress();
                            }
                        });
                    });

                    if (zipcodeInput.value && housenumberInput.value) {
                        validate();
                    }
                }
            } else if (mode == 'autocomplete') {
                // We need to use the Autocomplete system from postcode.eu from here on

                let postcodeAPILoaded = () =>
                    new Promise((resolve, reject) => {
                        let postcodeAPICounter = 0;
                        let postcodeAPITimer = setInterval(() => {
                            postcodeAPICounter++;
                            if (typeof PostcodeNl != undefined) {
                                clearInterval(postcodeAPITimer);
                                resolve();
                            } else if (postcodeAPICounter > 5) {
                                clearInterval(postcodeAPITimer);
                                reject();
                            }
                        }, 100);
                    });

                const input = this.content.querySelector(
                    `input#input_autocomplete`
                );

                const inputs = {
                    city: this.content.querySelector(`input[name="City"]`),
                    street: this.content.querySelector(`input[name="Street"]`),
                    postalCode: this.content.querySelector(
                        `input[name="PostalCode"]`
                    ),
                    houseNumber: this.content.querySelector(
                        `input[name="HouseNumber"]`
                    ),
                    houseNumberAddition: this.content.querySelector(
                        `input[name="HouseNumberAddition"]`
                    ),
                };

                if (input) {
                    const apiLoaded = postcodeAPILoaded();

                    apiLoaded.then(() => {
                        this.Autocomplete = new PostcodeNl.AutocompleteAddress(
                            input,
                            {
                                autocompleteUrl: '/api/zipcode/getautocomplete',
                                addressDetailsUrl: '/api/zipcode/getdetails',
                                showLogo: false,
                            }
                        );

                        input.addEventListener('autocomplete-select', (e) => {
                            const location = e.detail;
                            console.log(location);
                            if (
                                location &&
                                location.precision &&
                                location.precision == 'Address'
                            ) {
                                fetch(
                                    `/api/zipcode/getdetails?context=${location.context}`
                                )
                                    .then((response) => {
                                        return response.json();
                                    })
                                    .then((data) => {
                                        addressPreviewer.setAddress({
                                            street: data.street,
                                            houseNumber: data.buildingNumber,
                                            postalCode: data.postcode,
                                            city: data.locality,
                                            houseNumberAddition: data.buildingNumberAddition || '',
                                        });

                                        inputs.city.value = data.locality || '';
                                        inputs.street.value = data.street || '';
                                        inputs.postalCode.value =
                                            data.postcode || '';
                                        inputs.houseNumber.value =
                                            data.buildingNumber || '';
                                        inputs.houseNumberAddition.value =
                                            data.buildingNumberAddition || '';

                                        $(this.content.querySelector('form')).valid();
                                    });
                            }
                        });
                    });

                    const country = this.content.querySelector(
                        `select[name="Country"]`
                    );
                    if (country) {
                        apiLoaded.then(() => {
                            country.addEventListener(`change`, (e) => {
                                this.Autocomplete.setCountry(country.value);
                            });
                            this.Autocomplete.setCountry(country.value);
                        });
                    }
                }

                // import(/* webpackChunkName: "modules/postcodeAPI" */ `../modules/AutocompleteAddress`).then(e => {
                //     console.log(e);

                //     const autocomplete = e.default;
                //     const input = this.content.querySelector(`input#input_autocomplete`);

                //     if (input) {
                //         this.Autocomplete = PostcodeNl.AutocompleteAddress(input, {
                //             autocompleteUrl: '/api/zipcode/getautocomplete',
                //             addressDetailsUrl: '/api/zipcode/getdetails',
                //         })
                //     }
                // });
            }
        }

        if (this.content.querySelector(`.extraOptions`)) {
            this.content.querySelectorAll(`.extraOptions`).forEach(extraOptions => {

                const input = this.content.querySelector(`input[type="radio"][id="${extraOptions.dataset.id}"]`);
                const inputGroup = this.content.querySelectorAll(`input[type="radio"][name="${input.name}"]`);
                if (input) {
                    const update = () => {
                        extraOptions.classList.toggle(`active`, input.checked);

                        if (input.checked && extraOptions.querySelector(`input`)) {
                            extraOptions.querySelector(`input`).focus();
                        }
                    };

                    if (inputGroup && inputGroup.length) {
                        inputGroup.forEach((radio) => {
                            radio.addEventListener(`change`, update.bind(this));
                        });
                    }

                    input.addEventListener(`change`, update.bind(this));

                    update();
                } else {
                    // No trigger input found, assumme it's always visible
                    extraOptions.classList.add(`active`);
                }
            });
        }

        if (this.content.querySelector(`.fileUpload`)) {
            this.content
                .querySelectorAll(`.fileUpload`)
                .forEach((fileUpload) => {
                    const input = fileUpload.querySelector('input');
                    const label = fileUpload.querySelector('label');
                    const labelText = label.querySelector('span');
                    const list = fileUpload.querySelector('ul');

                    const updateList = () => {
                        const items = Array.from(input.files).map(
                            (file, index) => {
                                const listItem = document.createElement('li');
                                const removeButton =
                                    document.createElement('button');
                                const label = document.createElement('span');

                                removeButton.innerText = 'x';
                                label.innerText = file.name;
                                listItem.appendChild(removeButton);
                                listItem.appendChild(label);

                                removeButton.addEventListener('click', (e) => {
                                    e.preventDefault();
                                    const dt = new DataTransfer();

                                    for (
                                        let i = 0;
                                        i < input.files.length;
                                        i++
                                    ) {
                                        if (i !== index) {
                                            dt.items.add(input.files[i]);
                                        }
                                    }

                                    input.files = dt.files;
                                    updateList();
                                });

                                return listItem;
                            }
                        );

                        list.innerHTML = '';
                        items.forEach((item) => list.appendChild(item));
                    };

                    updateList();
                    input.addEventListener('change', updateList.bind(this));

                    // Allow drag over
                    label.addEventListener('dragover', (e) => {
                        e.preventDefault();
                        fileUpload.classList.add('dragover');
                    });

                    label.addEventListener('dragleave', () => {
                        fileUpload.classList.remove('dragover');
                    });

                    label.addEventListener('drop', (e) => {
                        e.preventDefault();
                        fileUpload.classList.remove('dragover');

                        const dt = new DataTransfer();

                        // Keep current files
                        Array.from(input.files).forEach((file) =>
                            dt.items.add(file)
                        );

                        // Add valid new files
                        if (e.dataTransfer.items) {
                            for (
                                let i = 0;
                                i < e.dataTransfer.items.length;
                                i++
                            ) {
                                const item = e.dataTransfer.items[i];

                                if (item.kind === 'file') {
                                    const file = item.getAsFile();
                                    if (file) {
                                        dt.items.add(file);
                                    }
                                }
                            }
                        } else {
                            // Fallback for browsers that only support files
                            for (
                                let i = 0;
                                i < e.dataTransfer.files.length;
                                i++
                            ) {
                                const file = e.dataTransfer.files[i];
                                dt.items.add(file);
                            }
                        }

                        input.files = dt.files;
                        updateList();
                    });
                });
        }

        if (this.content.querySelector(`select`)) {
            this.slimSelects = [];
            import(/* webpackChunkName: "modules/select" */ `slim-select`).then(
                (e) => {
                    const SlimSelect = e.default;

                    this.content
                        .querySelectorAll(`select`)
                        .forEach((select) => {
                            const options = {
                                showSearch: false,
                            };

                            // Setting overrides per select tag
                            if (select.dataset.ssSearch !== undefined) {
                                options.showSearch = true;
                                options.searchPlaceholder =
                                    select.dataset.ssSearch || `Zoeken`;
                                options.searchText =
                                    select.dataset.ssNoResults ||
                                    `Geen resultaten`;
                            }

                            if (select.dataset.ssDeselect !== undefined) {
                                options.allowDeselect = true;
                            }

                            let slimSelect = new SlimSelect({
                                select,
                                settings: options,
                            });

                            this.slimSelects.push(slimSelect);
                        });
                }
            );
        }

        // Special case. The input needs to have the select's input prefixed into the actual field
        if (this.content.querySelector(`.phoneInput`)) {
            const phoneContainer = this.content.querySelector(`.phoneInput`);
            const dropdown = phoneContainer.querySelector(`select`);
            const phoneSuffix = phoneContainer.querySelector(`input[name="PhoneNumberSuffix"]`);
            const phone = phoneContainer.querySelector(`input[name="PhoneNumber"]`);

            console.log({
                phoneContainer,
                dropdown,
                phoneSuffix,
                phone
            });

            const updatePhone = () => {  
               const trimmedPhoneSuffix = phoneSuffix?.value?.startsWith('0') 
                   ? phoneSuffix.value.slice(1) 
                   : phoneSuffix?.value || '';
               const phoneNumber = `${dropdown.value}${trimmedPhoneSuffix}`;  

               if (!trimmedPhoneSuffix) {  
                   phone.value = ``;  
               } else {  
                   phone.value = phoneNumber;  
               }  
            }

            dropdown.addEventListener(`change`, () => {
                updatePhone();
                
                setTimeout(() => {
                    phoneSuffix.focus();
                }, 50);
            });
            ['input', 'paste'].forEach((eventName) => {
                phoneSuffix.addEventListener(eventName, updatePhone.bind(this));
            });

            updatePhone();
        }

        if (this.content.querySelector(`duet-date-picker`)) {
            this.datepicker();
        }

        //#endregion

        // window.slimmage.cr();

        if (this.content.querySelector(`.labeledInput.validation`)) {
            const serialField = this.content.querySelector(
                `.labeledInput.validation`
            );
            const input = serialField.querySelector(`input`);
            const iconsContainer =
                serialField.querySelector(`.serialValidation`);
            const submitButton = this.content.querySelector(
                'button[type="submit"]'
            );

            const validate = () => {
                if (input.value && input.value.length >= 3) {
                    iconsContainer.dataset.state = 'loading';

                    // Reset waiter to prevent unneeded calls
                    if (this.serialValidator.changeWaiter !== null) {
                        clearTimeout(this.serialValidator.changeWaiter);
                    }

                    // Start a (new) timer that waits for x ms before actually polling data
                    this.serialValidator.changeWaiter = setTimeout(() => {
                        // If there's a call going on, abort it and create a new abortcontroller to reuse
                        if (this.serialValidator.abortController) {
                            this.serialValidator.abortController.abort();
                        }
                        this.serialValidator.abortController =
                            new AbortController();

                        fetch(
                            `${this.serialValidator.apiEndpoint}${input.value.trim()}`,
                            {
                                signal: this.serialValidator.abortController
                                    .signal,
                            }
                        ).then((response) => {
                            if (response.ok) {
                                iconsContainer.dataset.state = 'success';

                                submitButton.classList.remove('disabledButton');
                                submitButton.removeAttribute('disabled');
                            } else {
                                iconsContainer.dataset.state = 'error';
                                submitButton.classList.add('disabledButton');
                                submitButton.setAttribute(
                                    'disabled',
                                    'disabled'
                                );
                            }
                        });
                    }, this.serialValidator.waiterTime);
                } else {
                    iconsContainer.dataset.state = '';
                    submitButton.classList.add('disabledButton');
                    submitButton.setAttribute('disabled', 'disabled');
                }
            };

            setTimeout(() => validate(), 200);

            ['input', 'paste'].forEach((eventName) => {
                input.addEventListener(eventName, () => validate());
            });
        }
    }

    setEventListeners() {
        // Form submitting
        // this.delegate(this.formSelector, 'submit', e => {
        //     e.preventDefault();

        //     this.handleForm(e.target);
        // });

        this.listener = this.history.listen((info) => {
            if (info.action == 'POP') {
                if (info.location.pathname.length > this.currentPath.length) {
                    console.log('next');
                    this.handleNext();
                } else {
                    console.log('prev');
                    this.handlePrevious();
                }
            }
            this.currentPath = info.location.pathname;
        });

        this.delegate(`${this.formSelector} .inputRow input`, 'input', (e) => {
            const input = e.delegateTarget;
            const label = input.parentNode.querySelector('label');

            if (label) {
                if (input.value.length) {
                    label.classList.add('entered');
                } else {
                    label.classList.remove('entered');
                }
            }
        });

        this.delegate(`${this.formSelector} .clearForm`, 'click', (e) => {
            e.preventDefault();
            e.target.blur();
            document
                .querySelectorAll(`${this.formSelector} input`)
                .forEach((input) => {
                    switch (input.type) {
                        case 'checkbox':
                        case 'radio':
                            input.checked = false;
                            break;
                        case 'text':
                        case 'email':
                        case 'password':
                        case 'phone':
                        case 'number':
                            input.value = '';
                            break;
                    }
                });

            document
                .querySelectorAll(`${this.formSelector} textarea`)
                .forEach((textarea) => {
                    textarea.value = '';
                });
        });
    }

    handleForm(formEl) {
        // Collect info
        const action = formEl.getAttribute('action');
        // this.addLoading();

        const data = $(formEl).serializeArray();
        if (window.app.clickID) {
            data.push({
                name: `gclid`,
                value: window.app.clickID,
            });
        }

        $.ajax({
            type: 'POST',
            url: action,
            data: data,
            success: (data) => {
                this.processFormResponse(data);
            },
            complete: () => {
                // this.removeLoading();
            },
        });
    }

    processFormResponse(htmlString, back = false) {
        // Transform the string into DOM
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;

        let title = tempDiv.querySelector('title');
        let content = tempDiv.querySelector('main');

        if (title) {
            document.querySelector('title').innerHTML = title.innerHTML;
        }

        console.log(content);

        // At this point, everything went well. Start transitioning to the new form
        this.replaceContent(content, back);
    }

    replaceContent(content, back) {
        this.content.classList.add(back ? 'reverseOut' : 'out');

        setTimeout(() => {
            // Replace
            this.content.innerHTML = '';
            this.content.appendChild(content.firstElementChild);

            this.initForm();

            // If the new content contains a form, use that form's action to change the page's URL
            if (this.content.querySelector('form')) {
                let actionUrl = this.content
                    .querySelector('form')
                    .getAttribute('action');

                if (!back && actionUrl && location.pathname != actionUrl) {
                    this.history.push(actionUrl);
                    // this.ajaxCalls++;
                }
            }

            this.content.classList.add(back ? 'reverseIn' : 'in');
            setTimeout(() => {
                // Clean up
                this.content.classList.remove('reverseOut');
                this.content.classList.remove('out');
                this.content.classList.remove('reverseIn');
                this.content.classList.remove('in');
            }, this.animationDuration);
        }, this.animationDuration);
    }

    handlePrevious() {
        // this.addLoading();
        $.ajax({
            type: 'GET',
            url: location.pathname,
            success: (data) => {
                this.processFormResponse(data, true);
            },
            complete: () => {
                // this.removeLoading();
            },
        });
    }

    handleNext() {
        // this.addLoading();
        $.ajax({
            type: 'GET',
            url: location.pathname,
            success: (data) => {
                this.processFormResponse(data);
            },
            complete: () => {
                // this.removeLoading();
            },
        });
    }

    datepicker() {
        document.querySelectorAll(`duet-date-picker`).forEach((datepicker) => {
            
            window.customElements.define('duet-date-picker', this.DuetDatePicker);
            const DATE_FORMAT = /^(\d{1,2})\-(\d{1,2})\-(\d{4})$/;

            datepicker.dateAdapter = {
                parse(value = '', createDate) {
                    const matches = value.match(DATE_FORMAT);
                    if (matches) {
                        return createDate(matches[3], matches[2], matches[1]);
                    }
                },
                format(date) {
                    return `${date.getDate()}-${
                        date.getMonth() + 1
                    }-${date.getFullYear()}`;
                },
            };

            datepicker.localization = {
                buttonLabel: 'Selecteer datum',
                placeholder: 'dd-mm-jjjj',
                selectedDateMessage: 'Geselecteerde datum',
                prevMonthLabel: 'Vorige maand',
                nextMonthLabel: 'Volgende maand',
                monthSelectLabel: 'Maand',
                yearSelectLabel: 'Jaar',
                closeLabel: 'Sluiten',
                dayNames: [
                    'Zondag',
                    'Maandag',
                    'Dinsdag',
                    'Woensdag',
                    'Donderdag',
                    'Vrijdag',
                    'Zaterdag',
                ],
                monthNames: [
                    'Januari',
                    'Februari',
                    'Maart',
                    'April',
                    'Mei',
                    'Juni',
                    'Juli',
                    'Augustus',
                    'September',
                    'Oktober',
                    'November',
                    'December',
                ],
                monthNamesShort: [
                    'Jan',
                    'Feb',
                    'Mrt',
                    'Mei',
                    'Apr',
                    'Jun',
                    'Jul',
                    'Aug',
                    'Sep',
                    'Okt',
                    'Nov',
                    'Dec',
                ],
                locale: 'nl-NL',
            };
        });
    }
}
